module.exports = __webpack_public_path__ + "img/tazas.5f3c5fa3.webp";